module.exports = "/assets/b93cbd2fd4e95244f1cc8b260bf66b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BB.png
// module id = 1224
// module chunks = 0